const MODAL_ID = {
  MULTIPLE_COUNT_SIMULATION: "MULTIPLE_COUNT_SIMULATION",
  MASS_PRODUCTION_SIMULATION: "MASS_PRODUCTION_SIMULATION",
  SHARE_LINK: "SHARE_LINK",
  DELIVERY_ZERO: "DELIVERY_ZERO",
} as const

export default MODAL_ID
